import { View, Image } from 'react-native';
import { Text } from '@/components/Text';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import openURL from '@/utils/openLink';
import constants from '@/config/constants';
import { styles } from './styles';
import { Links } from '@/config/links';

function ProductInformations() {
  return (
    <View style={styles.container}>
      <View style={styles.leftCol}>
        <View style={styles.ceImageWrapper}>
          <Image
            style={styles.ceImage}
            resizeMode="contain"
            source={require('../../../assets/ce2.png')}
          />
        </View>
        <View>
          <Text style={styles.semiboldBase}>
            App Version {constants.appVersion}
          </Text>
          <Text style={styles.semiboldBase}>UDI-DI {constants.udiDi}</Text>
          <Text style={styles.semiboldBase}>UDI-PI {constants.udiPi()}</Text>
        </View>
      </View>
      <PressableNeolexon onPress={() => openURL(Links.impressum.href)}>
        <Text style={styles.semiboldLg}>Impressum</Text>
      </PressableNeolexon>
    </View>
  );
}

export default ProductInformations;
